export default function({ store, route, redirect, context }) {
  // console.log(context)
}
